import { useCallback, useMemo } from 'react';

import { useTagsSelect } from '../../utils/hooks/use-tags-select';

export function useAddTag() {
  const { search, valueItems, validCharRegex, onTagCreate } = useTagsSelect();

  const isVisible = useMemo(() => {
    if (search.trim() === '') return false;
    return !valueItems.some((item) => item.label === search);
  }, [search, valueItems]);

  const validationMsg = useMemo(() => {
    const isValid = validCharRegex.test(search);
    return isValid ? '' : 'Contains invalid characters';
  }, [validCharRegex, search]);

  const handleTagCreate = useCallback(
    (tag: string) => {
      if (validationMsg !== '') return;
      onTagCreate?.(tag);
    },
    [onTagCreate, validationMsg]
  );
  return {
    isValid: validationMsg === '',
    isVisible,
    onTagCreate: handleTagCreate,
    search,
    validationMsg,
  };
}
